import React from "react";
import { Form } from "formik";

import { Box, Button } from "shipnow-mercurio";
import { Grid } from "@mui/material";
import { InputFormik, SelectFormik } from "../../../common/components";
import { SEARCH_CP } from "../../../common/constants/links.consts";
import PropTypes from "prop-types";
import { ARGENTINA_STATES } from "../../../common/constants/settings.consts";

const DEFAULT_PROPS = {
  onChange: null,
};

export const AddressFormFormikSAP = (props) => {
  const attrs = { ...DEFAULT_PROPS, ...props };

  return (
    <Form>
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <SelectFormik
            label="Provincia"
            maxHeightOptions="320px"
            name="state"
            options={ARGENTINA_STATES}
            isOptional
            onChange={attrs.onChange}
          />
        </Grid>
        <Grid item xs={4}>
          <InputFormik
            label="Localidad o barrio"
            margin="b-20"
            name="city"
            isOptional
            onChange={attrs.onChange}
          />
        </Grid>

        <Grid item xs={2}>
          <InputFormik
            label="Código postal"
            margin="b-20"
            name="zip_code"
            type="number"
            onChange={attrs.onChange}
          />
        </Grid>

        <Grid item xs={3} lg={2}>
          <Box margin="t-26">
            <Button href={SEARCH_CP} type="link">
              Averiguar mi CP
            </Button>
          </Box>
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={4}>
          <InputFormik
            label="Calle"
            name="street_name"
            isOptional
            onChange={attrs.onChange}
          />
        </Grid>
        <Grid item xs={4}>
          <InputFormik
            id="street_number"
            label="Número"
            margin="b-20"
            name="street_number"
            isOptional
            onChange={attrs.onChange}
          />
        </Grid>
      </Grid>
    </Form>
  );
};

AddressFormFormikSAP.propTypes = {
  onChange: PropTypes.func,
};
